import axios from "axios";
import { UserInfo } from "../contexts/UserContext";
import { CollectionResponseDTO } from "../types/ApiTypes";
import { UserSearchResultType } from "../types/SearchTypes";
import { Role, User } from "../types/UserTypes";
import { PdlClub } from "../types/ClubTypes";

const API_URL = window.MLBBest.envVariables.SERVICES_URL + "/api/users";

export const UserApi = {
  getUserInfo: (): Promise<UserInfo> => axios.get(API_URL).then((response: { data: UserInfo }) => response.data),
  getUsers: (): Promise<UserSearchResultType[]> =>
    axios
      .get(API_URL + "/search")
      .then((response: { data: CollectionResponseDTO<UserSearchResultType> }) => response.data.collection),
  saveUsers: (users: User[]): Promise<User[]> =>
    axios.put(API_URL, users).then((response: { data: CollectionResponseDTO<User> }) => response.data.collection),
  saveRoles: (roles: Role[]): Promise<Role[]> =>
    axios
      .put(`${API_URL}/roles/update`, roles)
      .then((response: { data: CollectionResponseDTO<Role> }) => response.data.collection),
  updateActiveClub: (club: PdlClub): Promise<UserInfo> =>
    axios.post(`${API_URL}/active-club`, club).then((response: { data: UserInfo }) => response.data),
  getUsersByClubIds: (clubIds: number[]): Promise<UserSearchResultType[]> =>
    axios
      .get(`${API_URL}/search/by-club-ids`, {
        params: { clubIds },
        paramsSerializer: { indexes: null },
      })
      .then((response: { data: CollectionResponseDTO<UserSearchResultType> }) => response.data.collection),
  getUsersByOrgIds: (orgIds: number[]): Promise<UserSearchResultType[]> =>
    axios
      .get(`${API_URL}/search/by-org-ids`, {
        params: { orgIds },
        paramsSerializer: { indexes: null },
      })
      .then((response: { data: CollectionResponseDTO<UserSearchResultType> }) => response.data.collection),
  getUsersByClubIdsGrouped: (clubIds: number[]): Promise<Record<number, UserSearchResultType[]>> =>
    axios
      .get(`${API_URL}/search/by-club-ids-grouped`, {
        params: { clubIds },
        paramsSerializer: { indexes: null },
      })
      .then((response: { data: Record<number, UserSearchResultType[]> }) => response.data),
  getUsersGroupedForResponderManagement: (
    clubIds: number[],
    orgId?: number,
  ): Promise<{ clubUsers: Record<number, UserSearchResultType[]>; orgUsers: UserSearchResultType[] }> =>
    axios
      .get(`${API_URL}/search/grouped-for-responder-management`, {
        params: { clubIds, orgId },
        paramsSerializer: { indexes: null },
      })
      .then(
        (response: { data: { clubUsers: Record<number, UserSearchResultType[]>; orgUsers: UserSearchResultType[] } }) =>
          response.data,
      ),
};
